import React from 'react';
import { Link } from 'react-router-dom';

const F = "'Inter', system-ui, sans-serif";

export default function HeroSection({ heading, subheading, image }) {
  const hasImage = !!image;

  const heroStyle = {
    position: 'relative',
    overflow: 'hidden',
    minHeight: '580px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid #e5e7eb',
    ...(hasImage ? {
      backgroundImage: `linear-gradient(rgba(0,0,0,0.42), rgba(0,0,0,0.50)), url(${image})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    } : {
      background: 'linear-gradient(160deg, #ecfdf5 0%, #f0fdf4 40%, #f8fafc 75%, #ffffff 100%)',
    }),
  };

  return (
    <div style={heroStyle}>
      {!hasImage && (
        <>
          <div style={styles.blob1} />
          <div style={styles.blob2} />
        </>
      )}

      <div style={styles.content}>
        <div style={hasImage ? styles.badgeOnImage : styles.badge}>
          🌿 Willkommen in der Natur
        </div>
        <h1 style={{ ...styles.heading, color: hasImage ? '#ffffff' : '#0f172a', textShadow: hasImage ? '0 2px 12px rgba(0,0,0,0.3)' : 'none' }}>
          {heading}
        </h1>
        <p style={{ ...styles.subheading, color: hasImage ? 'rgba(255,255,255,0.88)' : '#64748b' }}>
          {subheading}
        </p>
        <div style={styles.actions}>
          <Link to="/buchung" style={styles.ctaPrimary}>Jetzt anfragen</Link>
          <Link to="/galerie" style={{ ...styles.ctaSecondary, ...(hasImage ? styles.ctaSecondaryOnImage : {}) }}>
            Galerie ansehen
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  blob1: {
    position: 'absolute', top: '-120px', right: '-100px',
    width: '560px', height: '560px', borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(30,132,73,0.08) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  blob2: {
    position: 'absolute', bottom: '-140px', left: '-80px',
    width: '440px', height: '440px', borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(30,132,73,0.05) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  content: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    padding: '5.5rem 2rem 6rem',
    maxWidth: '760px',
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4rem',
    backgroundColor: 'white',
    color: '#15803d',
    padding: '0.35rem 1rem',
    borderRadius: '20px',
    fontSize: '0.78rem',
    fontFamily: F,
    fontWeight: '600',
    letterSpacing: '0.5px',
    marginBottom: '1.75rem',
    boxShadow: '0 1px 8px rgba(0,0,0,0.08)',
    border: '1px solid #dcfce7',
  },
  badgeOnImage: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4rem',
    backgroundColor: 'rgba(255,255,255,0.18)',
    color: '#ffffff',
    padding: '0.35rem 1rem',
    borderRadius: '20px',
    fontSize: '0.78rem',
    fontFamily: F,
    fontWeight: '600',
    letterSpacing: '0.5px',
    marginBottom: '1.75rem',
    border: '1px solid rgba(255,255,255,0.35)',
    backdropFilter: 'blur(4px)',
  },
  heading: {
    fontSize: 'clamp(2.4rem, 5.5vw, 3.8rem)',
    fontFamily: F,
    fontWeight: '800',
    lineHeight: '1.1',
    marginBottom: '1.1rem',
    letterSpacing: '-1px',
  },
  subheading: {
    fontSize: 'clamp(1rem, 2.2vw, 1.15rem)',
    fontFamily: F,
    fontWeight: '400',
    lineHeight: '1.75',
    maxWidth: '540px',
    margin: '0 auto 2.75rem',
  },
  actions: {
    display: 'flex',
    gap: '0.85rem',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  ctaPrimary: {
    display: 'inline-block',
    backgroundColor: '#1e8449',
    color: 'white',
    textDecoration: 'none',
    padding: '0.95rem 2.4rem',
    borderRadius: '10px',
    fontWeight: '600',
    fontSize: '0.95rem',
    fontFamily: F,
    boxShadow: '0 4px 14px rgba(30,132,73,0.35)',
  },
  ctaSecondary: {
    display: 'inline-block',
    backgroundColor: 'white',
    color: '#374151',
    textDecoration: 'none',
    padding: '0.95rem 2.4rem',
    borderRadius: '10px',
    fontWeight: '500',
    fontSize: '0.95rem',
    fontFamily: F,
    border: '1.5px solid #e2e8f0',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  },
  ctaSecondaryOnImage: {
    backgroundColor: 'rgba(255,255,255,0.15)',
    color: '#ffffff',
    border: '1.5px solid rgba(255,255,255,0.5)',
    backdropFilter: 'blur(4px)',
    boxShadow: 'none',
  },
};
